(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ubpet-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const syncSelectorControls = (root, tabs, nextTab) => {
      const activeIndex = tabs.indexOf(nextTab);
      if (activeIndex < 0) return;
      root.dataset.ubhomeActiveIndex = String(activeIndex);
      root.querySelectorAll('[data-ubhome-selector-dot]').forEach((dot, index) => {
        if (index === activeIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
      const previous = root.querySelector('[data-ubhome-selector-prev]');
      const next = root.querySelector('[data-ubhome-selector-next]');
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === tabs.length - 1;
    };

    const activateTab = (root, nextTab, moveFocus = false, useTransition = true) => {
      const tabs = Array.from(root.querySelectorAll('[data-ubhome-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-ubhome-panel]'));
      if (!nextTab || !tabs.includes(nextTab)) return;
      const update = () => {
        tabs.forEach((tab) => {
          const active = tab === nextTab;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.id !== nextTab.dataset.target;
        });
        syncSelectorControls(root, tabs, nextTab);
      };
      if (useTransition && document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.startViewTransition(update);
      } else {
        update();
      }
      if (moveFocus) nextTab.focus();
    };

    const initSelector = (root) => {
      if (root.dataset.ubhomeReady === 'true') return;
      root.dataset.ubhomeReady = 'true';
      const tabs = Array.from(root.querySelectorAll('[data-ubhome-tab]'));
      const scroller = root.querySelector('.ubhome-selector__tabs');
      const previous = root.querySelector('[data-ubhome-selector-prev]');
      const next = root.querySelector('[data-ubhome-selector-next]');
      const dots = Array.from(root.querySelectorAll('[data-ubhome-selector-dot]'));
      const cleanups = [];
      let scrollFrame = 0;
      if (tabs.length === 0) return;
      const listen = (element, type, handler, options) => {
        if (!element) return;
        element.addEventListener(type, handler, options);
        cleanups.push(() => element.removeEventListener(type, handler, options));
      };
      const selectedIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      const initialIndex = selectedIndex >= 0 ? selectedIndex : 0;
      const scrollToIndex = (index, moveFocus = false) => {
        const targetTab = tabs[index];
        const card = targetTab?.closest('.ubhome-fit-card');
        if (!targetTab || !card) return;
        activateTab(root, targetTab, moveFocus);
        if (!scroller || scroller.scrollWidth <= scroller.clientWidth + 2) return;
        const left = Math.max(0, Math.min(card.offsetLeft - 20, scroller.scrollWidth - scroller.clientWidth));
        scroller.scrollTo({
          left,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      const syncFromScroll = () => {
        if (!scroller || tabs.length < 2) return;
        const scrollerRect = scroller.getBoundingClientRect();
        const scrollerCenter = scrollerRect.left + scrollerRect.width / 2;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;
        tabs.forEach((tab, index) => {
          const card = tab.closest('.ubhome-fit-card');
          if (!card) return;
          const cardRect = card.getBoundingClientRect();
          const distance = Math.abs(cardRect.left + cardRect.width / 2 - scrollerCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        if (Number(root.dataset.ubhomeActiveIndex) !== closestIndex) {
          activateTab(root, tabs[closestIndex], false, false);
        }
      };
      const onScroll = () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(syncFromScroll);
      };
      tabs.forEach((tab, index) => {
        const onClick = () => {
          if (scroller && scroller.scrollWidth > scroller.clientWidth + 2) {
            scrollToIndex(index);
          } else {
            activateTab(root, tab);
          }
        };
        const onKeydown = (event) => {
          let targetIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') targetIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') targetIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') targetIndex = 0;
          if (event.key === 'End') targetIndex = tabs.length - 1;
          if (targetIndex !== index) {
            event.preventDefault();
            scrollToIndex(targetIndex, true);
          }
        };
        listen(tab, 'click', onClick);
        listen(tab, 'keydown', onKeydown);
      });
      listen(previous, 'click', () => {
        const index = Math.max(0, Number(root.dataset.ubhomeActiveIndex) - 1);
        scrollToIndex(index);
      });
      listen(next, 'click', () => {
        const index = Math.min(tabs.length - 1, Number(root.dataset.ubhomeActiveIndex) + 1);
        scrollToIndex(index);
      });
      dots.forEach((dot) => {
        listen(dot, 'click', () => scrollToIndex(Number(dot.dataset.index)));
      });
      listen(scroller, 'scroll', onScroll, { passive: true });
      syncSelectorControls(root, tabs, tabs[initialIndex]);
      root._ubhomeSelectorCleanup = () => {
        cleanups.forEach((cleanup) => cleanup());
        cancelAnimationFrame(scrollFrame);
        delete root._ubhomeSelectorCleanup;
        delete root.dataset.ubhomeReady;
      };
    };

    const initFaq = (root) => {
      if (root.dataset.ubhomeReady === 'true') return;
      root.dataset.ubhomeReady = 'true';
      const items = Array.from(root.querySelectorAll('details'));
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item) other.removeAttribute('open');
          });
        });
      });
    };

    const initHero = (root) => {
      if (root.dataset.ubhomeReady === 'true') return;
      root.dataset.ubhomeReady = 'true';

      const slides = Array.from(root.querySelectorAll('[data-ubhome-hero-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-ubhome-hero-dot]'));
      const previous = root.querySelector('[data-ubhome-hero-prev]');
      const next = root.querySelector('[data-ubhome-hero-next]');
      const toggle = root.querySelector('[data-ubhome-hero-toggle]');
      const toggleLabel = toggle?.querySelector('.ubhome-hero__toggle-label');
      const status = root.querySelector('[data-ubhome-hero-status]');
      if (slides.length < 2 || !previous || !next || !toggle) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const compactView = window.matchMedia('(max-width: 760px)');
      const interval = Math.max(4000, Number.parseInt(root.dataset.interval || '7000', 10));
      const cleanups = [];
      let activeIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));
      let userPaused = root.dataset.autoplay !== 'true' || reducedMotion.matches;
      let interactionPaused = false;
      let timer = null;
      let pointerStart = null;

      const listen = (target, eventName, handler, options) => {
        target.addEventListener(eventName, handler, options);
        cleanups.push(() => target.removeEventListener(eventName, handler, options));
      };

      const clearTimer = () => {
        if (timer !== null) window.clearTimeout(timer);
        timer = null;
      };

      const updateToggle = () => {
        if (reducedMotion.matches) {
          toggle.dataset.state = 'paused';
          toggle.setAttribute('aria-pressed', 'true');
          if (toggleLabel) toggleLabel.textContent = '手動';
          toggle.setAttribute('aria-label', '自動切り替えは端末設定により停止中');
          return;
        }
        toggle.dataset.state = userPaused ? 'paused' : 'playing';
        toggle.setAttribute('aria-pressed', String(userPaused));
        if (toggleLabel) toggleLabel.textContent = userPaused ? '再生' : '停止';
        toggle.setAttribute('aria-label', userPaused ? '自動切り替えを再開' : '自動切り替えを停止');
      };

      const render = () => {
        slides.forEach((slide, index) => {
          const active = index === activeIndex;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, index) => {
          const active = index === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
        if (status) status.textContent = `${activeIndex + 1} / ${slides.length}`;
        updateToggle();
      };

      const canRotate = () => !userPaused && !interactionPaused && !document.hidden && !reducedMotion.matches && !compactView.matches;

      const schedule = () => {
        clearTimer();
        if (!canRotate()) return;
        timer = window.setTimeout(() => {
          activeIndex = (activeIndex + 1) % slides.length;
          render();
          schedule();
        }, interval);
      };

      const show = (index, pause = false) => {
        activeIndex = (index + slides.length) % slides.length;
        if (pause) userPaused = true;
        render();
        schedule();
      };

      dots.forEach((dot) => listen(dot, 'click', () => show(Number.parseInt(dot.dataset.slideIndex || '0', 10), true)));
      listen(previous, 'click', () => show(activeIndex - 1, true));
      listen(next, 'click', () => show(activeIndex + 1, true));
      listen(toggle, 'click', () => {
        if (reducedMotion.matches) return;
        userPaused = !userPaused;
        render();
        schedule();
      });

      listen(root, 'mouseenter', () => {
        interactionPaused = true;
        clearTimer();
      });
      listen(root, 'mouseleave', () => {
        interactionPaused = false;
        schedule();
      });
      listen(root, 'focusin', () => {
        interactionPaused = true;
        clearTimer();
      });
      listen(root, 'focusout', (event) => {
        if (event.relatedTarget && root.contains(event.relatedTarget)) return;
        interactionPaused = false;
        schedule();
      });
      listen(root, 'pointerdown', (event) => {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
      });
      listen(root, 'pointerup', (event) => {
        if (!pointerStart || pointerStart.id !== event.pointerId) return;
        const deltaX = event.clientX - pointerStart.x;
        const deltaY = event.clientY - pointerStart.y;
        pointerStart = null;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.25) return;
        show(activeIndex + (deltaX < 0 ? 1 : -1), true);
      });
      listen(root, 'pointercancel', () => { pointerStart = null; });
      listen(document, 'visibilitychange', schedule);
      const onReducedMotionChange = () => {
        if (reducedMotion.matches) userPaused = true;
        render();
        schedule();
      };
      reducedMotion.addEventListener('change', onReducedMotionChange);
      cleanups.push(() => reducedMotion.removeEventListener('change', onReducedMotionChange));
      const onCompactViewChange = () => schedule();
      compactView.addEventListener('change', onCompactViewChange);
      cleanups.push(() => compactView.removeEventListener('change', onCompactViewChange));

      const onBlockSelect = (event) => {
        const selectedSlide = event.target.closest('[data-ubhome-hero-slide]');
        if (!selectedSlide || !root.contains(selectedSlide)) return;
        show(Number.parseInt(selectedSlide.dataset.slideIndex || '0', 10), true);
      };
      listen(document, 'shopify:block:select', onBlockSelect);

      root._ubhomeHeroCleanup = () => {
        clearTimer();
        cleanups.forEach((cleanup) => cleanup());
        delete root._ubhomeHeroCleanup;
      };
      render();
      schedule();
    };

    const initMobileCta = (root) => {
      if (root.dataset.ubhomeReady === 'true') return;
      const footer = document.querySelector('#shopify-section-footer-group, footer');
      if (!footer || !('IntersectionObserver' in window)) return;
      root.dataset.ubhomeReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        root.classList.toggle('is-footer-visible', Boolean(entries[0]?.isIntersecting));
      }, { rootMargin: '0px 0px 72px 0px', threshold: 0 });
      observer.observe(footer);
      root._ubhomeMobileCtaCleanup = () => {
        observer.disconnect();
        delete root._ubhomeMobileCtaCleanup;
      };
    };


    const init = (scope = document) => {
      scope.querySelectorAll('[data-ubhome-hero]').forEach(initHero);
      scope.querySelectorAll('[data-ubhome-selector]').forEach(initSelector);
      scope.querySelectorAll('[data-ubhome-faq]').forEach(initFaq);
      scope.querySelectorAll('[data-ubhome-mobile-cta]').forEach(initMobileCta);
    };

    init();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-ubhome-hero]').forEach((hero) => hero._ubhomeHeroCleanup?.());
      event.target.querySelectorAll('[data-ubhome-selector]').forEach((selector) => selector._ubhomeSelectorCleanup?.());
      event.target.querySelectorAll('[data-ubhome-mobile-cta]').forEach((cta) => cta._ubhomeMobileCtaCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ubpet-product-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ubpet-detail-scroller')) {
    customElements.define(
      'ubpet-detail-scroller',
      class UbpetDetailScroller extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-ubpet-detail-track]');
          this.previousButton = this.querySelector('[data-ubpet-detail-previous]');
          this.nextButton = this.querySelector('[data-ubpet-detail-next]');

          if (!this.track || !this.previousButton || !this.nextButton) return;

          this.cards = Array.from(this.track.querySelectorAll('.ubpet-story__detail-card'));
          this.compactMedia = window.matchMedia('(max-width: 899px)');
          this.onScroll = () => {
            window.cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = window.requestAnimationFrame(() => this.updateControls());
          };
          this.onViewportChange = () => window.requestAnimationFrame(() => this.updateControls());
          this.onKeydown = (event) => {
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            this.move(event.key === 'ArrowLeft' ? -1 : 1);
          };
          this.onPrevious = () => this.move(-1);
          this.onNext = () => this.move(1);

          this.previousButton.addEventListener('click', this.onPrevious);
          this.nextButton.addEventListener('click', this.onNext);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('keydown', this.onKeydown);
          this.compactMedia.addEventListener?.('change', this.onViewportChange);

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(() => this.updateControls());
            this.cards.forEach((card) => this.resizeObserver.observe(card));
          }

          window.requestAnimationFrame(() => this.updateControls());
        }

        disconnectedCallback() {
          if (!this.track) return;
          this.previousButton?.removeEventListener('click', this.onPrevious);
          this.nextButton?.removeEventListener('click', this.onNext);
          this.track.removeEventListener('scroll', this.onScroll);
          this.track.removeEventListener('keydown', this.onKeydown);
          this.compactMedia?.removeEventListener?.('change', this.onViewportChange);
          window.cancelAnimationFrame(this.scrollFrame);
          this.resizeObserver?.disconnect();
        }

        move(direction) {
          const firstCard = this.track.querySelector('.ubpet-story__detail-card');
          const styles = window.getComputedStyle(this.track);
          const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
          const distance = (firstCard?.getBoundingClientRect().width || this.track.clientWidth) + gap;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

          this.track.scrollBy({ left: distance * direction, behavior });
        }

        updateControls() {
          const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const currentScroll = Math.max(0, this.track.scrollLeft);
          this.previousButton.disabled = currentScroll <= 4;
          this.nextButton.disabled = currentScroll >= maxScroll - 4;
          this.updateTrackHeight();
        }

        updateTrackHeight() {
          if (!this.compactMedia?.matches) {
            this.track.style.removeProperty('height');
            return;
          }

          if (!this.cards?.length) return;

          const viewportCenter = this.track.scrollLeft + this.track.clientWidth / 2;
          const activeCard = this.cards.reduce((closest, card) => {
            const cardCenter = card.offsetLeft + card.offsetWidth / 2;
            const closestCenter = closest.offsetLeft + closest.offsetWidth / 2;
            return Math.abs(cardCenter - viewportCenter) < Math.abs(closestCenter - viewportCenter) ? card : closest;
          }, this.cards[0]);
          const paddingBottom = Number.parseFloat(window.getComputedStyle(this.track).paddingBottom) || 0;
          const targetHeight = Math.ceil(activeCard.getBoundingClientRect().height + paddingBottom);

          if (targetHeight > 0 && Math.abs(this.track.getBoundingClientRect().height - targetHeight) > 1) {
            this.track.style.height = `${targetHeight}px`;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
